<template>
  <div class="search-page">
    <!-- 顶部导航 -->
    <div class="header">
      <div class="back-btn" @click="goBack">
        <svg viewBox="0 0 24 24" class="back-icon"><path d="M15 4 L7 12 L15 20" fill="none" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </div>
      <form class="search-box" @submit.prevent="doSearch">
        <svg viewBox="0 0 24 24" class="search-icon"><circle cx="11" cy="11" r="7" fill="none" stroke="#999" stroke-width="2"/><path d="M16 16 L21 21" stroke="#999" stroke-width="2" stroke-linecap="round"/></svg>
        <input v-model="keyword" type="search" class="search-input" placeholder="请输入关键字搜索" />
        <svg v-if="keyword" viewBox="0 0 24 24" class="clear-btn" @click.prevent="clearKeyword"><circle cx="12" cy="12" r="10" fill="#ccc"/><path d="M8.5 8.5 L15.5 15.5 M15.5 8.5 L8.5 15.5" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/></svg>
      </form>
    </div>

    <!-- 默认态：热门搜索 + 历史搜索 -->
    <template v-if="!searched">
      <div class="section">
        <div class="section-title">热门搜索</div>
        <div class="hot-tags">
          <span v-for="t in hotList" :key="t" class="hot-tag" @click="searchWord(t)">{{ t }}</span>
        </div>
      </div>

      <div class="section history-section">
        <div class="section-title-row">
          <div class="section-title">历史搜索</div>
          <svg viewBox="0 0 24 24" class="clear-icon" @click="clearHistory">
            <path d="M5 7 h14 M10 7 V5 h4 v2 M7 7 l1 13 h8 l1-13" fill="none" stroke="#b2b2b2" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.5 11 v5 M13.5 11 v5" stroke="#b2b2b2" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
        </div>
        <div v-if="history.length" class="history-list">
          <div v-for="(h, i) in history" :key="h + i" class="history-row">
            <span class="history-text" @click="searchWord(h)">{{ h }}</span>
            <svg viewBox="0 0 24 24" class="remove-icon" @click="removeHistory(i)"><path d="M6 6 L18 18 M18 6 L6 18" stroke="#c8c9cc" stroke-width="1.8" stroke-linecap="round"/></svg>
          </div>
        </div>
        <div v-else class="empty-tip">暂无搜索记录</div>
      </div>
    </template>

    <!-- 搜索结果 -->
    <div v-else class="section result-section">
      <div class="section-title">应用</div>
      <div v-if="results.length" class="result-list">
        <div v-for="r in results" :key="r.title" class="result-row" @click="goService(r)">
          <img :src="getIcon(r.icon)" class="result-icon" :alt="r.title" />
          <span class="result-title">
            <span v-for="(p, j) in highlight(r.title)" :key="j" :class="{ hl: p.hl }">{{ p.text }}</span>
          </span>
          <svg viewBox="0 0 24 24" class="result-arrow"><path d="M9 5 L16 12 L9 19" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
      </div>
      <div v-else class="empty-tip">未找到相关结果</div>
    </div>
  </div>
</template>

<script>
import serviceGroups from '@/data/services'
import { navigateWithLoading } from '@/utils/loading'

const iconContext = require.context('@/assets/icons', false, /\.png$/)
const icons = {}
iconContext.keys().forEach(key => {
  const name = key.replace(/^\.\//, '').replace(/\.png$/, '')
  icons[name] = iconContext(key)
})

const allServices = []
serviceGroups.forEach(g => {
  g.items.forEach(it => {
    allServices.push({ title: it.title, group: g.name, color: g.color, icon: it.icon, path: it.path })
  })
})

const HIST_KEY = 'search-history'

export default {
  name: 'SearchPage',
  data() {
    return {
      keyword: '',
      searched: false,
      results: [],
      hotList: ['参保', '就业', '培训', '社保卡'],
      history: []
    }
  },
  created() {
    try {
      this.history = JSON.parse(localStorage.getItem(HIST_KEY) || '[]')
    } catch (e) {
      this.history = []
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    getIcon(name) {
      return icons[name] || ''
    },
    highlight(title) {
      const kw = this.keyword.trim()
      if (!kw) return [{ text: title, hl: false }]
      const parts = []
      let i = 0
      while (i < title.length) {
        const idx = title.indexOf(kw, i)
        if (idx === -1) {
          parts.push({ text: title.slice(i), hl: false })
          break
        }
        if (idx > i) parts.push({ text: title.slice(i, idx), hl: false })
        parts.push({ text: kw, hl: true })
        i = idx + kw.length
      }
      return parts
    },
    doSearch() {
      const kw = this.keyword.trim()
      if (!kw) return
      this.searched = true
      this.results = allServices.filter(s => s.title.indexOf(kw) > -1 || s.group.indexOf(kw) > -1)
      this.history = [kw].concat(this.history.filter(h => h !== kw)).slice(0, 15)
      localStorage.setItem(HIST_KEY, JSON.stringify(this.history))
    },
    clearKeyword() {
      this.keyword = ''
      this.searched = false
      this.results = []
    },
    searchWord(word) {
      this.keyword = word
      this.doSearch()
    },
    removeHistory(index) {
      this.history.splice(index, 1)
      localStorage.setItem(HIST_KEY, JSON.stringify(this.history))
    },
    clearHistory() {
      this.history = []
      localStorage.setItem(HIST_KEY, JSON.stringify(this.history))
    },
    goService(r) {
      // 有具体路由的服务项直接跳转（如个人权益记录查询打印 → /rights-record-print）
      if (r && r.path) {
        navigateWithLoading(r.path, 2000)
      } else {
        navigateWithLoading('/service', 2000)
      }
    }
  }
}
</script>

<style scoped>
.search-page {
  background: #f0f0f0;
  min-height: 100%;
}
/* 顶部导航 */
.header {
  display: flex;
  align-items: center;
  height: calc(130 * var(--w));
  background: #fff;
  border-bottom: 1px solid #e5e5e5;
  padding-right: calc(60 * var(--w));
}
.back-btn {
  width: calc(110 * var(--w));
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
}
.back-icon {
  width: calc(36 * var(--w));
  height: calc(36 * var(--w));
}
.search-box {
  flex: 1;
  height: calc(88 * var(--w));
  border: calc(2 * var(--w)) solid #e0e0e0;
  border-radius: calc(44 * var(--w));
  display: flex;
  align-items: center;
  padding: 0 calc(30 * var(--w));
  margin-left: calc(30 * var(--w));
  background: #fff;
}
.search-icon {
  width: calc(40 * var(--w));
  height: calc(40 * var(--w));
  flex-shrink: 0;
}
.search-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: calc(44 * var(--w));
  color: #333;
  margin-left: calc(16 * var(--w));
  -webkit-appearance: none;
}
.search-input::-webkit-search-cancel-button {
  -webkit-appearance: none;
}
/* 分区 */
.section {
  background: #fff;
  padding: calc(36 * var(--w)) calc(34 * var(--w)) calc(50 * var(--w));
}
.history-section {
  margin-top: calc(32 * var(--w));
}
.section-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.section-title {
  font-size: calc(60 * var(--w));
  font-weight: bold;
  color: #f0a230;
}
.clear-icon {
  width: calc(44 * var(--w));
  height: calc(44 * var(--w));
  cursor: pointer;
}
/* 热门搜索标签 */
.hot-tags {
  display: flex;
  flex-wrap: wrap;
  gap: calc(44 * var(--w));
  margin-top: calc(72 * var(--w));
}
.hot-tag {
  height: calc(64 * var(--w));
  line-height: calc(62 * var(--w));
  padding: 0 calc(40 * var(--w));
  border: calc(2 * var(--w)) solid #d8d8d8;
  border-radius: calc(32 * var(--w));
  font-size: calc(54 * var(--w));
  color: #4a4a4a;
  cursor: pointer;
}
/* 历史搜索 */
.history-list {
  margin-top: calc(12 * var(--w));
}
.history-row {
  display: flex;
  align-items: center;
  height: calc(137 * var(--w));
  border-bottom: 1px solid #f0f0f0;
}
.history-row:last-child {
  border-bottom: none;
}
.history-text {
  flex: 1;
  font-size: calc(60 * var(--w));
  color: #333;
  cursor: pointer;
}
.remove-icon {
  width: calc(40 * var(--w));
  height: calc(40 * var(--w));
  flex-shrink: 0;
  cursor: pointer;
}
/* 搜索结果 */
.result-section {
  padding: calc(36 * var(--w)) 0 calc(50 * var(--w));
}
.result-section .section-title {
  padding: 0 calc(34 * var(--w));
}
.result-list {
  margin-top: calc(8 * var(--w));
}
.result-row {
  display: flex;
  align-items: center;
  height: calc(170 * var(--w));
  padding: 0 calc(34 * var(--w));
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
}
.result-row:last-child {
  border-bottom: none;
}
.result-icon {
  width: calc(60 * var(--w));
  height: calc(60 * var(--w));
  object-fit: contain;
  flex-shrink: 0;
}
.result-title {
  flex: 1;
  font-size: calc(48 * var(--w));
  color: #333;
  margin-left: calc(28 * var(--w));
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.result-title .hl {
  color: #ff976a;
}
.result-arrow {
  width: calc(32 * var(--w));
  height: calc(32 * var(--w));
  flex-shrink: 0;
}
.clear-btn {
  width: calc(40 * var(--w));
  height: calc(40 * var(--w));
  flex-shrink: 0;
  margin-left: calc(16 * var(--w));
  cursor: pointer;
}
.empty-tip {
  margin-top: calc(60 * var(--w));
  text-align: center;
  font-size: calc(48 * var(--w));
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/pages/SearchPage.vue